import { render, staticRenderFns } from "./campaign-design-section.vue?vue&type=template&id=1e083e36"
import script from "./campaign-design-section.vue?vue&type=script&lang=js"
export * from "./campaign-design-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports